import React from 'react';
import PropTypes from 'prop-types';
import PropTypesPreset from '../../Util/PropTypesPreset';
import FormInput from '../../components/Form/FormInput';
import FormContainer from '../../components/Form/FormContainer';
import { Link } from 'react-router-dom';
import { Snackbar, ButtonBase, CircularProgress } from '@material-ui/core';
import update from 'immutability-helper';
import { signin as Language } from '../../Util/language.json';
import { withHoc } from '../../Context/Provider';
import { siteMapForCwr } from '../../Util/siteMap';
import { asyncTokenCheck, asyncSignIn } from '../../Util/AuthUtility';

const propTypes = {
  history: PropTypes.shape(PropTypesPreset.history).isRequired,
  auth: PropTypes.shape({
    displayName: PropTypes.string,
    id: PropTypes.string,
    emailverified: PropTypes.bool,
    use: PropTypes.bool,
    processing: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape(PropTypesPreset.match).isRequired,
  tokenCheck: PropTypes.func,
  isTokenCheck: PropTypes.bool,
  siginIn: PropTypes.func,
  authInfoUpdate: PropTypes.func,
  dataInit: PropTypes.func,
};
const defaultProps = {
  history: {},
  auth: {
    displayName: '',
    id: '',
    emailverified: null,
    use: null,
    processing: '',
  },
  match: {},
  tokenCheck: null,
  isTokenCheck: false,
  signIn: null,
  authInfoUpdate: null,
};

class Sign extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      password: '',
      toast: null,
      isLoading: false,
    };
    this.clearToastTimeOut = this.clearToastTimeOut.bind(this);
    this.handelrSubmit = this.handelrSubmit.bind(this);
    this.handlerInputChange = this.handlerInputChange.bind(this);
    this.handlerSnackbarHide = this.handlerSnackbarHide.bind(this);
    this.toast = this.toast.bind(this);
  }

  async componentDidMount() {
    const { dataInit, authInfoUpdate, match, history } = this.props;
    dataInit();

    try {
      const { Auth, status } = await asyncTokenCheck();
      if (status === 200) {
        authInfoUpdate(Auth, status, () => {
          if (Auth.is_admin) {
            window.location.href = '/cms';
          } else {
            siteMapForCwr(Auth, this.props.match, this.props.history);
          }
        });
      }
    } catch ({ Auth, status }) {
      if (status === 403) {
        authInfoUpdate(Auth, status, () => {
          this.props.history.replace('/expired');
        });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { auth } = nextProps;
    const { id, password, isLoading, toast } = this.state;
    const {
      id: idNext,
      password: passwordNext,
      isLoading: isLoadingNext,
      toast: toastNext,
    } = nextState;
    if (this.props.auth !== auth) {
      return true;
    } else if (
      id !== idNext ||
      password !== passwordNext ||
      isLoading !== isLoadingNext ||
      toast !== toastNext
    ) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    this.clearToastTimeOut();
    delete this.idForSnackbar;
  }

  clearToastTimeOut = () => {
    if (this.timeoutToast) {
      clearTimeout(this.timeoutToast);
      delete this.timeoutToast;
    }
  };

  handlerInputChange = e => {
    const { name, value } = e.target;
    this.setState(update(this.state, { [name]: { $set: value } }));
  };

  toast = msg => {
    this.clearToastTimeOut();
    this.setState(update(this.state, { toast: { $set: msg } }));
    this.timeoutToast = setTimeout(() => {
      this.setState(update(this.state, { toast: { $set: null } }));
    }, 1500);
  };

  handelrSubmit = async e => {
    e.preventDefault();
    const { id, password } = this.state;
    const { authInfoUpdate } = this.props;

    this.setState({
      isLoading: true,
    });

    try {

      const { auth, status } = await asyncSignIn(id, password);
      if (status === 200) {
        this.setState({
          isLoading: false,
        });
        authInfoUpdate(auth, status, () => {
          if (auth.is_admin) {
            window.location.href = '/cms';
          } else {
            siteMapForCwr(auth, this.props.match, this.props.history);
          }
        });
      }
    } catch ({ auth, status }) {
      if (status === 404) {
        this.setState({
          isLoading: false,
        });
        this.toast(Language.errorNotFoundID);
      } else if (status === 406) {
        this.setState({
          isLoading: false,
        });
        this.toast(Language.errorNotMatchPW);
      } else if (status === 412) {
        this.setState({
          isLoading: false,
        });
        this.toast(Language.errorEmail);
      } else if (status === 403) {
        this.setState({
          isLoading: false,
        });
        authInfoUpdate(auth, status, () => {
          this.props.history.replace('/expired');
        });
      }
    }
  };

  handlerSnackbarHide = () => {
    this.setState(update(this.state, { toast: { $set: null } }));
  };
  render() {
    const { id, password, toast, isLoading } = this.state;
    return (
      <FormContainer id="page--main" caption={Language.version}>
        <form
          className="sign"
          onSubmit={this.handelrSubmit}
          target={'_blank'}
          autoComplete={'on'}
        >
          <FormInput
            idForm
            name="id"
            type="text"
            placeholder={Language.id}
            value={id}
            autoComplete="username"
            onChange={this.handlerInputChange}
          />
          <input
            className="sign"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder={Language.password}
            value={password}
            onChange={this.handlerInputChange}
          />
          <ButtonBase
            color="primary"
            type="submit"
            disabled={isLoading}
            classes={{ root: 'submit--login' }}
          >
            {isLoading ? (
              <div className="progress-container">
                <CircularProgress />
              </div>
            ) : (
                Language.signin
              )}
          </ButtonBase>
        </form>
        <Link className="link color-secondary" to="/passwordreset">
          {Language.passwordReset}
        </Link>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          snackbarcontentprops={{ 'aria-describedby': this.idForSnackbar }}
          open={Boolean(toast)}
          onClose={this.handlerSnackbarHide}
          message={<span id={this.idForSnackbar}>{toast}</span>}
        />
      </FormContainer>
    );
  }
}

Sign.propTypes = propTypes;
Sign.defaultProps = defaultProps;

export default withHoc(Sign);
